import React, {useEffect, useCallback, useState} from 'react'
import { useNavigate } from "react-router-dom";
import { getUnatHolders } from '../../util/api'
import { debounce } from 'lodash';
import { 
  Spinner,
  IconButton,
  Typography,
  Input,
  Progress,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
  Radio,
  Dialog,
  DialogBody,
  Button
} from '@material-tailwind/react';
import { formatUnixTime } from '../../util/format-data';
import { v4 as uuidv4 } from 'uuid';
import { formatAddress } from '../../util/format-data';
import Op20IndexerDetail from './Op20IndexerDetail';
import { getOp20Indexer } from '../../util/op20-api';
import { useTranslation } from 'react-i18next';
import { formatFloat } from '../../util/format-data';
import { ArrowRightIcon, ArrowLeftIcon, ChevronLeftIcon, ChevronRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, FunnelIcon, ArrowLongDownIcon, ArrowLongUpIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { formatNumberWithCommas } from '../../util/format-data';
import { convertTimestampToDate } from '../../util/format-data';
import { getMezcalIndexer } from '../../util/mezcal-api';
import MezcalIndexerDetail from './MezcalIndexerDetail';

export default function MezcalIndexer() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [ticker, setTicker] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [sort, setSort] = useState(0); // 0: holders, 1: supply, 2: percentage, 4: createdAt
  const [direct, setDirect] = useState(1); // 0: ASC, 1: DESC
  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState([]);
  const [showDetail, setShowDetail] = useState(false);
  const [status, setStatus] = useState("all");
  const [detailticker, setDetailTicker] = useState('');
  const [showInfo, setShowInfo] = useState(false);
  const [detailData, setDetailData] = useState({});

  useEffect(() => {
    fetchTokenData(ticker, page);
  }, [page])

  useEffect(() => {
    fetchTokenData(ticker, 1);
    setPage(1);
  }, [status])

  const next = () => {
    if (page === total) return;
    setPage(page + 1);
  };
 
  const prev = () => {
    if (page === 1) return;
    setPage(page - 1);
  };

  const doublePrev = () => {
    setPage(1);
  }

  const doubleNext = () => {
    setPage(total);
  }

  const handleKeyChange = (e) => {
    setTicker(e.target.value)
    debouncedSearch(e.target.value)
  }

  const handleOrder = (value) => {
    setSort(value);
    setDirect(1 - direct);
  }

  const debouncedSearch = useCallback(debounce( async (value) => {
    try {
      await fetchTokenData(value, 1);
      setPage(1);
    }
    catch (e) {
      console.log(e);
    }
  }, 300), []); 

  const fetchTokenData = async (value, page) => {
    setLoading(true);
    let data = await getMezcalIndexer(value, status,  page, limit);
    setDatas(data.data.etchings);
    setTotal(Math.ceil(data.data.total_etchings / limit));
    setLoading(false);
  }

  const showDetailIndexer = (value) => {
    setDetailData(value);
    setShowDetail(true);
  }

  const handleShowInfo = (e, data) => {
    e.preventDefault();
    e.stopPropagation();
    setShowInfo(true);
    setDetailData(data);
  }
  return (
    <div className="text-white w-full max-w-[1800px] flex flex-col justify-center items-center">
      {
        loading ? <Spinner className="h-16 w-16 text-gray-900/50 fixed top-[50%] left-[50%]" color="pink"/> : <></>
      }
      {
        showDetail ? <MezcalIndexerDetail detailData = {detailData} handleShowDetail = {setShowDetail} setLoading = {setLoading}/> : 
        <>
          <div className="flex flex-row justify-start w-full font-bold text-primary text-[20px] mt-8">
            <Radio 
              name="type" 
              color="pink" 
              checked={status == "all"}
              onChange={() => setStatus("all")}
              className={`${status == "all" ? 'border-primary' : 'border-white'}`}
              label={
                <Typography
                className={`flex font-medium  ${status == "all" ? 'text-primary' : 'text-white'}`}
                >
                  {t('ALL')}
                </Typography>
              } 
            />
            <Radio 
              name="type" 
              color="pink" 
              checked={status == "in-progress"}
              onChange={() => setStatus("in-progress")}
              className={`${status == "in-progress" ? 'border-primary' : 'border-white'}`}
              label={
                <Typography
                className={`flex font-medium  ${status == "in-progress" ? 'text-primary' : 'text-white'}`}
                >
                  {t('In Progress')}
                </Typography>
              } 
              defaultChecked 
            />
            <Radio 
              name="type" 
              color="pink" 
              checked={status == "completed"}
              onChange={() => setStatus("completed")}
              className={`${status == "completed" ? 'border-primary' : 'border-white'}`}
              label={
                <Typography
                  className={`flex font-medium  ${status == "completed" ? 'text-primary' : 'text-white'}`}
                >
                  {t('Completed')}
                </Typography>
              } 
            />
          </div>
          {
            <div className="flex flex-col gap-2 max-w-[1600px] w-full">
              { 
                <div className="mt-3 flex flex-row w-full justify-end gap-2">
                  <div>
                    <Input type="text" color="white" label = {t('Search By Ticker')} className="w-[250px]" value = {ticker} onChange = {(e) => {handleKeyChange(e)}}/>
                  </div>
                </div>
              }
              <div className="flex flex-row px-4 py-2 items-center">
                <div className = "md:w-[12%] w-[50%]">{t('Ticker')}</div>
                <div className = "md:w-[8%] w-[30%] flex flex-row gap-1 items-center">
                  <span>{t('Holders')}</span>
                  {/* <div className="flex flex-row cursor-pointer" onClick={() =>handleOrder(0)}>
                    <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 0 && direct == 1 ? 'text-primary' : 'text-white'}`} />
                    <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 0 && direct == 0 ? 'text-primary' : 'text-white'}`} />
                  </div> */}
                </div>
                <div className = "md:w-[13%] md:flex flex-row items-center gap-1 hidden">
                  <span>{t('Supply')}</span>
                  {/* <div className="flex flex-row cursor-pointer" onClick={() =>handleOrder(1)}>
                    <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 1 && direct == 1 ? 'text-primary' : 'text-white'}`} />
                    <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 1 && direct == 0 ? 'text-primary' : 'text-white'}`} />
                  </div> */}
                </div>
                <div className = "md:w-[11%] md:flex flex-row items-center gap-1 hidden">
                  <span>{t('Max Mints')}</span>
                </div>
                <div className = "md:w-[15%] md:flex flex-row gap-1 items-center hidden">
                  <span>{t('Progress')}</span>
                  {/* <div className="flex flex-row cursor-pointer" onClick={() =>handleOrder(2)}>
                    <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 2 && direct == 1 ? 'text-primary' : 'text-white'}`} />
                    <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 2 && direct == 0 ? 'text-primary' : 'text-white'}`} />
                  </div> */}
                </div>
                <div className = "md:w-[11%] md:block hidden">{t('DeploymentId')}</div>
                <div className = "md:w-[11%] md:block hidden">{t('Deployer')}</div>
                <div className = "md:w-[11%] md:flex flex-row gap-1 items-center hidden">
                  <span>{t('Block')}</span>
                  {/* <div className="flex flex-row cursor-pointer" onClick={() =>handleOrder(3)}>
                    <ArrowLongDownIcon strokeWidth={2} className={`h-4 w-4 ${sort == 3 && direct == 1 ? 'text-primary' : 'text-white'}`} />
                    <ArrowLongUpIcon strokeWidth={2} className={`h-4 w-4 ml-[-8px] ${sort == 3 && direct == 0 ? 'text-primary' : 'text-white'}`} />
                  </div> */}
                </div>
                <div className = "md:w-[8%] w-[20%] text-center">{t('Action')}</div>
              </div>
              {
                datas.map((data) => 
                  <div 
                    className="flex flex-row gap-1 items-center text-white bg-gray-900 p-4 rounded-lg cursor-pointer" 
                    key={uuidv4()}
                    onClick = {() => showDetailIndexer(data)}
                  >
                    <div className = "md:w-[12%] w-[50%] flex flex-row gap-2 items-center">
                      <div className="w-[30px] h-[30px] rounded-md bg-primary flex items-center justify-center min-w-[30px]">
                        <div className="text-white font-bold break-words">{data.symbol}</div>
                      </div>
                      <div className="text-primary font-bold break-words max-w-[100px]">{data.name}</div>
                    </div>
                    <div className = "md:w-[8%] w-[30%]">{formatNumberWithCommas(data.total_holders)}</div>
                    <div className = "md:w-[13%] md:block hidden">{formatNumberWithCommas(parseInt(data.total_supply) / parseInt(Math.pow(10, data.decimals)))}</div>
                    <div className = "md:w-[11%] md:block hidden">{data.mint_cap ?formatNumberWithCommas(parseInt(data.mint_cap)) : '-'}</div>
                    <div className = "md:w-[15%] md:flex hidden text-blue-600 flex-row items-center gap-2">
                      {data.unmintable == 1 ?
                        <div className="text-red-500">{t('Unmintable')}</div>
                        :
                        <>
                        <div className="w-[100px] md:block hidden">
                          <Progress  value={Math.ceil(parseInt(parseFloat(data.mints) / parseFloat(data.mint_cap) * 100))} color="blue" size="sm" />
                        </div>
                        <div>{formatFloat(parseInt(parseFloat(data.mints) / parseFloat(data.mint_cap) * 100), 2)}%</div>
                        </>
                      }
                    </div>
                    <div className = "md:w-[11%] md:block hidden hover:text-primary">
                      <a href={`https://mempool.space/tx/${data.etch_transaction}`} target="_blank" rel="noopener noreferrer" >{formatAddress(data.etch_transaction)}</a></div>
                    <div className = "md:w-[11%] md:block hidden">{formatAddress(data.deployer_address)}</div>
                    <div className = "md:w-[11%] md:block hidden">{data.block}</div>
                    <div className = "md:w-[8%] w-[20%] flex flex-row justify-center">
                      <div className="w-[40px] border-[1px] border-borderColor border-solid text-[20px] rounded-md font-bold text-center cursor-pointer p-[6px] hover:border-primary hover:text-primary" onClick = {(e) => {handleShowInfo(e, data)}}>
                        <InformationCircleIcon strokeWidth={2} className="h-6 w-6" />
                      </div>
                    </div>
                  </div>
                )
              }
            </div> 
          }
          {
            total > 1 ? 
            <div className="flex flex-row items-center gap-8 justify-end mt-5">
              <div className="flex flex-row items-center gap-2">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={doublePrev}
                  disabled={page === 1}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronDoubleLeftIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={prev}
                  disabled={page === 1}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronLeftIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
              <Typography color="white" className="font-normal">
                {t('Page')} <strong className="text-primary">{page}</strong> of{" "}
                <strong className="text-primary">{total}</strong>
              </Typography>
              <div className="flex flex-row items-center gap-2">
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={next}
                  disabled={page === total}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronRightIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
                <IconButton
                  size="sm"
                  variant="outlined"
                  onClick={doubleNext}
                  disabled={page === total}
                  className="bg-primary hover:bg-primary-hover"
                >
                  <ChevronDoubleRightIcon strokeWidth={2} className="h-4 w-4" />
                </IconButton>
              </div>
            </div>
            :
            <></>
          }
          <Dialog
            open={showInfo}
            size={"xs"}
            className="bg-black border-solid border-[1px] border-gray-600"
          >
            <DialogBody>
              <div className="flex flex-col w-full gap-3 p-3 h-[500px] overflow-y-auto">
                <div className="flex flex-row text-center justify-center items-center w-full text-primary gap-1">
                  <InformationCircleIcon strokeWidth={2} className="h-12 w-12" />
                  <span className="text-[32px] font-bold text-primary">{t('Details')}</span>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Protocol Id')}</div>
                  <div className="text-white">{detailData.mezcal_protocol_id}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Name')}</div>
                  <div className="text-white">{detailData.name}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Symbol')}</div>
                  <div className="text-white">{detailData.symbol}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Total Supply')}</div>
                  <div className="text-white">{formatNumberWithCommas(parseInt(detailData.total_supply) / parseInt(Math.pow(10, detailData.decimals)))}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Decimal')}</div>
                  <div className="text-white">{detailData.decimals}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Premine')}</div>
                  <div className="text-white">{formatNumberWithCommas(parseInt(detailData.premine) / parseInt(Math.pow(10, detailData.decimals)))}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Max Mints')}</div>
                  <div className="text-white">{detailData.mint_cap ? formatNumberWithCommas(parseInt(detailData.mint_cap)) : '-'}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Minted')}</div>
                  <div className="text-white">{formatNumberWithCommas(parseInt(detailData.mints))}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Unit Mint')}</div>
                  <div className="text-white">{detailData.mint_amount ? formatNumberWithCommas(parseInt(detailData.mint_amount) / parseInt(Math.pow(10, detailData.decimals))) : '-'}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Burned')}</div>
                  <div className="text-white">{formatNumberWithCommas(parseInt(detailData.burnt_amount) / parseInt(Math.pow(10, detailData.decimals)))}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Holders')}</div>
                  <div className="text-white">{formatNumberWithCommas(parseInt(detailData.total_holders))}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('TxId')}</div>
                  <div className="text-white break-all">{detailData.etch_transaction}</div>
                </div>
                <div className="flex flex-col border-b-[1px] border-gray-900 pb-1 px-2">
                  <div className="text-[#9a9790]">{t('Deployer')}</div>
                  <div className="text-white break-all">{detailData.deployer_address}</div>
                </div>
              </div>
              <div className="flex flex-row-reverse w-full mt-2">
                <Button  onClick={() => setShowInfo(false)}>{t('RETURN')}</Button>
              </div>
            </DialogBody>
          </Dialog>
        </>
      }
      
    </div>
  )
}
